export default "__VITE_ASSET__D_Abh_1u__"